export const DropboxFileProviderDisplayName = "Tjc";
export const BoxFileProviderDisplayName = "Ujc";
export const GoogleDriveFileProviderDisplayName = "Vjc";
export const FacebookFileProviderDisplayName = "Wjc";
export const RecentAttachmentsFileProviderDisplayName = "Xjc";
export const EgnyteFileProviderDisplayName = "Yjc";
export default {DropboxFileProviderDisplayName,BoxFileProviderDisplayName,GoogleDriveFileProviderDisplayName,FacebookFileProviderDisplayName,RecentAttachmentsFileProviderDisplayName,EgnyteFileProviderDisplayName};